import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_2 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_11 = {
  key: 1,
  class: "form-check form-group form-switch m-0"
}
const _hoisted_12 = ["checked", "id", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.roles !== undefined && _ctx.roles.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('feature.roles.journey_schemas')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.journey_schemas === undefined)
              ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                  key: 0,
                  class: "mt-50"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('form.title.label')), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                          return (_openBlock(), _createElementBlock("th", {
                            scope: "col",
                            class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0",
                            key: role.id
                          }, _toDisplayString(_ctx.$t(`feature.roles.$type.${role.type}`)), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createCommentVNode(" class=\"linked\" "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.journey_schemas, (schema) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: schema.id
                        }, [
                          _createElementVNode("td", _hoisted_9, _toDisplayString(schema.name), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "shadow-none lh-1 fw-medium text-black-emphasis",
                              key: role.id
                            }, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", null, [
                                  (_ctx.loading_schema_id === schema.id + '_' + role.id)
                                    ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                                        key: 0,
                                        class: "h-auto",
                                        style: {"width":"30px"},
                                        small: true
                                      }))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("input", {
                                          class: "form-check-input shadow-none",
                                          type: "checkbox",
                                          role: "switch",
                                          checked: _ctx.schema_has_role(schema, role),
                                          id: `${schema.id}-link`,
                                          onChange: ($event) => _ctx.updateSchema(schema, role, $event)
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12)
                                      ]))
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_AlertModal, {
      id: `alertModalZoneSchemas_${_ctx.zone_id}`,
      title: _ctx.$t('feature.roles.remind_journey_schemas.title'),
      message: _ctx.$t('feature.roles.remind_journey_schemas.message'),
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alertModal?.hide()))
    }, null, 8 /* PROPS */, ["id", "title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}